// extracted by mini-css-extract-plugin
module.exports = {"noDataFound":"NoDataFound_noDataFound__fIZTX"};